/* eslint-disable @typescript-eslint/triple-slash-reference */
// tslint:disable-next-line: no-reference
/// <reference path='../../images.d.ts'/>
import { ReactComponent as RegularFace } from '../../assets/svg/face-neutral.svg';
export default RegularFace;
